export const SURVEY_FORM_FIELDS = {
  TOP_IMAGE_URL: 'top_image_url',
  TOP_IMAGE_FILE: 'top_image_file',
  TITLE: 'title',
  DESCRIPTION: 'description',
  QUESTIONS: 'questions',
  STATUS: 'status',
  EXPIRES_IN: 'expires_in',
  SLUG: 'slug',
  CONFIG: 'config',
}

export const SURVEY_QUESTION_FIELDS = {
  KEY: 'key',
  ID: 'id',
  TITLE: 'title',
  TYPE: 'type',
  OPTIONAL: 'optional',
  ORDER: 'order',
  LINEAR_SCALE: 'linear_scale',
  SELECT: 'select'
}

export const SURVEY_QUESTION_TYPE = {
  TEXT: 1,
  MULTILINE: 2,
  LINEAR_SCALE: 3,
  SELECT: 4
};

export const questionTypes = [
  { id: SURVEY_QUESTION_TYPE.TEXT, name: 'Texto simples' },
  { id: SURVEY_QUESTION_TYPE.MULTILINE, name: 'Texto multilinha' },
  { id: SURVEY_QUESTION_TYPE.LINEAR_SCALE, name: 'Escala' },
  { id: SURVEY_QUESTION_TYPE.SELECT, name: 'Seleção' }
];

export const newQuestionPayload = {
  [SURVEY_QUESTION_FIELDS.TITLE]: 'Nova Questão',
  [SURVEY_QUESTION_FIELDS.TYPE]: questionTypes.find(type => +type.id === +SURVEY_QUESTION_TYPE.MULTILINE),
  [SURVEY_QUESTION_FIELDS.OPTIONAL]: false,
}

export const SURVEY_CONFIG_FIELDS = {
  USER_INPUTS: 'user_inputs',
  HAS_UNLIMITED_ANSWERS: 'has_unlimited_answers'
}

export const SURVEY_QUESTION_LINEAR_SCALE_FIELDS = {
  FROM: 'from',
  FROM_TEXT: 'from_text',
  TO: 'to',
  TO_TEXT: 'to_text'
}

export const SURVEY_QUESTION_SELECT_FIELD = {
  IS_MULTIPLE_SELECTION: 'is_multiple_selection',
  OPTIONS: 'options'
}

export const SURVEY_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
  /**
   * Status para ser usado somente com contas da Voitto, com "@voitto.com.br"
   */
  INTERNAL: 2,
};

export const surveyStatusOptions = [
  {
    id: SURVEY_STATUS.ACTIVE,
    name: 'Ativo',
    tooltip: 'Status para indicar que a pesquisa está ativa',
  },
  {
    id: SURVEY_STATUS.INACTIVE,
    name: 'Inativo',
    tooltip: 'Status para indicar que a pesquisa está inativa',
  },
  {
    id: SURVEY_STATUS.INTERNAL,
    name: 'Interno',
    tooltip:
      'Status para indicar que a pesquisa está disponível somente para contas @voitto.com.br',
  },
];

export const SURVEY_USER_FIELDS = {
  NAME: 'name',
  EMAIL: 'email',
  PHONE: 'phone'
}

export const alwaysRequiredUserFieldIDs = [SURVEY_USER_FIELDS.NAME, SURVEY_USER_FIELDS.EMAIL];

export const userFieldsOptions = [
  { value: SURVEY_USER_FIELDS.NAME, label: 'Nome' },
  { value: SURVEY_USER_FIELDS.EMAIL, label: 'Email' },
  { value: SURVEY_USER_FIELDS.PHONE, label: 'Celular' },
]